import Styles from "./Spinner.module.css";

export default function Spinner() {
  return <p className={`${Styles.loading}`}> Loading...</p>;
}
